fetch(`./assets/config/app-config.json`)
  .then((res) => res.json())
  .then((data) => {
    window.__webpack_public_path__ = (data?.publicPath?.endsWith('/') ?
      data.publicPath : (data?.publicPath || '') + '/') || '/';
    // Cache the parsed config so ConfigHandler can reuse it without a second HTTP
    // round-trip. The window property is intentionally namespaced to avoid collisions.
    (window as any).__SM_APP_CONFIG__ = data;
  })
  .then(() => import('./bootstrap'))
  .catch(err => console.error(err));
